(() => {
    const search = document.querySelector('.header-vehicle-search');
    if (!search) {
        return;
    }

    const makeSelect = search.querySelector('select[name="Make"]');
    const modelSelect = search.querySelector('select[name="Model"]');
    const originalModels = [];
    search.querySelectorAll('select[name="Model"] option').forEach((option) => {
        originalModels.push(option.cloneNode(true));
    });

    const updateVisibleModels = () => {
        const currentValue = modelSelect.value;
        modelSelect.innerHTML = '';

        if (!makeSelect.value) {
            originalModels.forEach(option => modelSelect.appendChild(option.cloneNode(true)));
        } else {
            originalModels.forEach(option => {
                if (option.value === '') {
                    modelSelect.appendChild(option.cloneNode(true));
                    return;
                }

                if (option.getAttribute('data-make') !== makeSelect.value) {
                    return;
                }

                option.innerText = option.getAttribute('data-model-label');
                modelSelect.appendChild(option.cloneNode(true));
            });
        }

        if (currentValue && modelSelect.querySelector(`option[value="${currentValue}"]`)) {
            modelSelect.value = currentValue;
        }
    };

    updateVisibleModels();
    makeSelect.addEventListener('change', updateVisibleModels);
})();
